@let isMinusDisabled = Number(value()) === bottomLimit || disabled;
<div [class]="classes">
  <button
    type="button"
    tabindex="-1"
    (click)="decrement()"
    [disabled]="isMinusDisabled"
    aria-label="Decrease value"
    [attr.aria-controls]="id"
    class="shrink-0 rounded-sm leading-3"
  >
    <csl-icon
      [name]="'minus'"
      [ngClass]="{
        'bg-[--counter-icon-color]': !isMinusDisabled,
        'bg-[--counter-disabled-icon-color]': isMinusDisabled,
      }"
      class="size-6 shrink-0"
    ></csl-icon>
  </button>
  @if (withInput) {
    <input
      type="text"
      maxlength="2"
      [id]="id"
      class="w-full text-center outline-none"
      [disabled]="disabled"
      [attr.aria-label]="ariaLabel || null"
      [attr.aria-labelledby]="ariaLabelledby || null"
      [ngClass]="{
        'bg-[--counter-disabled-bg-color] text-[--counter-disabled-text-color]': disabled,
        'min-w-36': size === 'md',
        'min-w-16': size === 'sm',
      }"
      [value]="value()"
      (input)="inputChange($event)"
      [cslInputPattern]="numberPattern"
      role="spinbutton"
      [attr.aria-valuemax]="topLimit"
      [attr.aria-valuemin]="bottomLimit"
      [attr.aria-valuenow]="value()"
      [attr.aria-required]="ariaRequired"
      [attr.aria-invalid]="ariaInvalid"
      [attr.aria-describedby]="ariaDescribedby"
    />
  } @else {
    <span
      [ngClass]="{
        'text-[--counter-disabled-text-color]': disabled,
        'min-w-36': size === 'md',
        'min-w-16': size === 'sm',
      }"
      class="w-full text-center text-base font-normal leading-normal"
      data-testid="question-answer"
      >{{ value() }}</span
    >
  }

  @let isPlusDisabled = Number(value()) === topLimit || disabled;
  <button
    type="button"
    tabindex="-1"
    (click)="increment()"
    [disabled]="isPlusDisabled"
    aria-label="Increase value"
    [attr.aria-controls]="id"
    class="shrink-0 rounded-sm leading-3"
  >
    <csl-icon
      [name]="'plus'"
      [ngClass]="{
        'bg-[--counter-icon-color]': !isPlusDisabled,
        'bg-[--counter-disabled-icon-color]': isPlusDisabled,
      }"
      class="size-6 shrink-0"
    ></csl-icon>
  </button>
</div>
